import WaybillsTableColumnActions from './index.vue'
export default WaybillsTableColumnActions